module.exports = __webpack_public_path__ + "static/media/confirm-agreement-selected.31b41d48.svg";